/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./cover-dialog.vue?vue&type=template&id=29048c58&scoped=true&"
import script from "./cover-dialog.vue?vue&type=script&lang=js&"
export * from "./cover-dialog.vue?vue&type=script&lang=js&"
import style0 from "./cover-dialog.vue?vue&type=style&index=0&id=29048c58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29048c58",
  null
  
)

export default component.exports